import Dashboard from 'components/Admin/Dashboard/Dashboard';
import {BrowserRouter as Router , Route, Routes, Navigate} from 'react-router-dom'
import CompanyList from 'components/Admin/Companies/CompanyList';
import Plans from 'components/Admin/Plans/PlanList';
import Stores from 'components/Admin/Stores/StoresList';
import StoreEditor from 'components/Admin/Stores/StoreEditor';
import Users from 'components/Admin/Users/UsersList';
import Orders from 'components/Admin/Orders/OrdersList';
import {Permissions} from './Permissions'; 
import MasterLogs from 'components/Admin/MasterLogs/MasterLogs';
import Subscriptions from 'components/Companies/Subscriptions/Subscriptions';
import SubscriptionEditor from 'components/Companies/Subscriptions/SubscriptionEditor';

import LinkWebflow from 'components/Companies/Webflow/Link';

import Account from 'components/Companies/Account/AccountEditor';
import EmailChangeVerification from 'components/Companies/Account/Components/EmailChangeVerification';
import Coupons from 'components/Companies/Coupons/CouponsList'
import Logic from 'components/Companies/Logic/Logic';
import { Fragment, useEffect } from 'react';
import Taxes from 'components/Companies/Taxes/Taxes';
import Shipping from 'components/Companies/Shipping/Zones/ShippingList';
import { ApiRequest } from 'GlobalFunctions';
import Shippo from 'components/Companies/Shipping/Shippo/Shippo';
import InvoiceEditor from 'components/Companies/Invoice/InvoiceEditor';
import Payment from 'components/Companies/Payment/Payment';
import StoreOrders from 'components/Companies/Orders/OrdersList';
import Oauth from 'components/Oauth/Oauth';
import OauthAdmin from 'components/Admin/Oauth/Oauth';
import TaxTypes from 'components/Admin/Taxes/Types/TypesList';
import TaxRates from 'components/Admin/Taxes/Rates/RatesList';
import TaxCategories from 'components/Admin/Taxes/Categories/CategoriesList';
import TaxSettings from 'components/Companies/Taxes/Settings/TaxSettings';
import OrdersDetails from 'components/Companies/Orders/OrdersDetails';
import OrderEditor from 'components/Companies/Orders/OrderEditor';

const componentMap: any = {
  Dashboard,
  CompanyList,
  Plans,
  Stores,
  Users,
  Orders,
  MasterLogs,
  Account,
  Coupons,
  Logic,
  Taxes,
  Shipping,
  InvoiceEditor,
  StoreOrders,
  Subscriptions,
  SubscriptionEditor,
  TaxTypes,
  TaxRates,
  TaxCategories,
  TaxSettings,
}





export default function AppRoutes(props:any) {
  const role_id = Number(localStorage.getItem('role_id'));
  const store_id = localStorage.getItem('store_id');
  const {setLoading, GetUserInfo} = props;

  // Validate token on route navigation
  useEffect(() => {
    const validateToken = async () => {
      const ltkn = localStorage.getItem('ltkn');
      if (!ltkn) return;

      await ApiRequest({
        url: '/users/validate_token',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        setResponse: (response: any) => {
          if (response.status === 'error') {
            // Token is invalid, clear all localStorage and reload
            localStorage.clear();
            window.location.reload();
          }
        }
      });
    };

    validateToken();
  }, [window.location.pathname]); // Re-validate when route changes

  // Solo redirigir a /account si no hay store_id, el role_id es 1, 
  // y no estamos ya en la ruta /account o /accept-transfer para evitar bucle infinito
  if (!store_id && role_id === 1 && window.location.pathname !== '/account' && window.location.pathname !== '/accept-transfer') {
    return <Navigate to="/account" replace />;
  }

  return (
    <>
      <Routes>
          {Permissions.map((permission, index) => {
            if (permission.role_id === role_id) {
              const DefaultComponent = componentMap[permission.defaultComponent];
              
              // Aquí debe retornar
              return (
                <Fragment key={index}>
                  <Route path="/" element={<Navigate to={permission.defaultComponent} />} />
                  {permission.routes.map((route, index) => {
                    return route.components.map((item, index) => {
                      const Component = componentMap[item.component];
                      return <Route key={index} path={item.path} 
                        element={
                          <Component 
                            setLoading={setLoading} 
                            GetUserInfo={GetUserInfo}
                          />
                        } 
                      />
                    });
                  })}
                  <Route path="*" element={<Navigate to={permission.defaultComponent} />} />
                </Fragment>
              );
            }
            return null; // Retorna null si no cumple la condición
          })}
         
         <Route path="/orders/:order_id" element={<OrdersDetails setLoading={setLoading}/>} />
         <Route path="/orders/:order_id/edit" element={<OrderEditor setLoading={setLoading}/>} />
                    
          <Route path="/stores/:store_id" element={<StoreEditor setLoading={setLoading}/>} />
          <Route path="/logic" element={<Logic setLoading={setLoading}/>} />
          <Route path="/webflow" element={<LinkWebflow setLoading={setLoading}/>} />
          <Route path="/pay" element={<Payment setLoading={setLoading}/>} />

          <Route path="/oauth" element={<Oauth setLoading={setLoading}/>} />
          <Route path="/admin/oauth" element={<OauthAdmin setLoading={setLoading}/>} />
          <Route path="/shipping/shippo" element={<Shippo setLoading={setLoading}/>} />
          <Route path="/subscriptions/:subscription_id" element={<SubscriptionEditor setLoading={setLoading}/>} />
          <Route path="/taxes/tax-types" element={<TaxTypes setLoading={setLoading}/>} />
          <Route path="/taxes/tax-categories" element={<TaxCategories setLoading={setLoading}/>} />
          
          <Route path="/taxes/settings" element={<TaxSettings setLoading={setLoading}/>} />
          
          <Route path="/verify-email-change" element={<EmailChangeVerification setLoading={setLoading}/>} />
          
          <Route path="/accept-transfer" element={<Account setLoading={setLoading} GetUserInfo={GetUserInfo}/>} />

      </Routes>
    </>
  );
}